<script>
    import EngageButtons from "./EngageButtons.svelte";
    import Card from "./Card.svelte";

    export let stim;
	
</script>

 
 
<div
    class="media-card"
    card-idx={stim.idx}
    entity-id={stim.entity_id}
 >
    <div>
        <Card
            entity_url={stim.entity_url}
            entity_id={stim.entity_id}
            idx={stim.idx}
        />
    </div>
    <EngageButtons {stim} idx={stim.idx} />
</div>

<style>
	@media (max-width: 700px) {
		.media-card {
			padding-top: 34px !important;
			padding-bottom: 34px !important;
			border-top: 1px solid rgba(232, 232, 232, 0.4);
			border-bottom: 1px solid rgba(232, 232, 232, 0.4);
			border-left: 0 !important;
			border-right: 0 !important;
			padding-left: 0 !important;
			padding-right: 0 !important;
		}
	}
	.media-card {
		padding: 21px 13px 21px 13px;
		line-height: 13px;
		font-size: 11px;
		width: 89%;
		margin: auto;
		border: 1px solid rgb(50, 41, 47, 0.05);
		border-radius: 0.2rem;
	}
	.media-card:hover {
		background-color: rgb(50, 41, 47, 0.008);
		border: 1px solid rgb(50, 41, 47, 0.1);
	}
</style>